import React, { useState, useEffect } from 'react';
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Alert,
  InputGroup,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { allCustomerInfos } from '../../pages/Customers/CustomersSlice';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  getDataCustomerUsers,
  saveUser,
} from '../../pages/CustomerUsers/CustomerUsersSlice';

const addUserSchema = yup.object().shape({
  name: yup.string(),
  email: yup
    .string()
    .required('Email is a required field.')
    .email('Invalid email format.'),
  password: yup.string(),
});

const ModalAddCustomerUsers = ({ show, setShow, customerId }) => {
  const token = localStorage.getItem('token');
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [validated, setValidated] = useState(false);
  const allCustomer = useSelector(allCustomerInfos);
  const customerInfo = allCustomer.data?.filter(
    (item) => item.id.id === customerId
  )[0];

  const handleClose = () => {
    resetField('name');
    resetField('email');
    setValidated(false);
    setShow(false);
  };

  const {
    register,
    resetField,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addUserSchema),
  });

  const [pwdShown, setPwdShown] = useState(false);

  const onSubmit = () => {
    const name = getValues('name');
    const email = getValues('email');
    const tenantId = customerInfo.tenantId.id;
    const password = getValues('password');

    dispatch(
      saveUser({
        token,
        tenantId,
        customerId,
        name,
        email,
        password,
      })
    );

    resetField('name');
    resetField('email');
    resetField('password');
    setValidated(false);
    setShow(false);
    dispatch(getDataCustomerUsers({ token, customerId }));
  };

  useEffect(() => {
    if (errors.name || errors.email) {
      setValidated(true);
    } else setValidated(false);
  }, [errors]);

  return (
    <Modal onHide={handleClose} size="lg" show={show}>
      <Modal.Header closeButton>
        <Modal.Title>{t('add-new-user')}</Modal.Title>
      </Modal.Header>
      <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="customerId">
                <Form.Label>{t('customer-id')}:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t('customer-id')}
                  value={customerId}
                  disabled
                />
              </Form.Group>
              <Form.Group as={Col} controlId="name">
                <Form.Label>{t('name')}:</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder={t('name')}
                  {...register('name')}
                />
                {errors.name && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.name.message}</p>
                  </Alert>
                )}
              </Form.Group>
              <Form.Group as={Col} controlId="email">
                <Form.Label>
                  {' '}
                  <span>
                    <i
                      class="fa fa-asterisk"
                      style={{ color: 'red', fontSize: '10px' }}
                      aria-hidden="true"
                    ></i>{' '}
                  </span>
                  {t('email')}:
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t('email')}
                  {...register('email')}
                />
                {errors.email && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.name.message}</p>
                  </Alert>
                )}
              </Form.Group>
              <Form.Group as={Col} controlId="formPlaintextPassword">
                <Form.Label>
                  <span>
                    <i
                      class="fa fa-asterisk"
                      style={{ color: 'red', fontSize: '10px' }}
                      aria-hidden="true"
                    ></i>{' '}
                  </span>
                  {t('password')}
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    type={pwdShown ? 'text' : 'password'}
                    placeholder={t('password')}
                    {...register('password')}
                  />
                  <InputGroup.Text>
                    <i
                      className={
                        !pwdShown ? 'feather icon-eye-off' : 'feather icon-eye'
                      }
                      onClick={() => {
                        setPwdShown(!pwdShown);
                      }}
                    ></i>
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t('close')}
          </Button>
          <Button variant="primary" type="submit">
            {t('add-new')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalAddCustomerUsers;
